<app-page-header>{{ 'Violations' }}</app-page-header>

<app-widget-group [data]="visibleStatuses" (widgetSelected)="updateSelectedStatus($event)"></app-widget-group>
<app-table class="violations-table"
           [columnMap]="columnMap"
           [columnSort]="columnSort"
           [type]="tableType"
           [rowSelectable]="true"
           (showFilters)="openFilters($event)"
           (rowSelect)="goToViolationStatement($event)"
           (loaded)="showStatuses()"
           matSort
           matSortActive="reportedAt"
           matSortDirection="desc"
           matSortDisableClear="true">
    <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[0].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.title">
            <app-avatar-block [svgIcon]="'v2:fi-br-triangle-warning'">
                <a [routerLink]="[row.id, 'details']" [queryParams]="queryParams" avatarTitle>{{ row.title }}</a>
                <span avatarDescription>{{ row.organization.name }}</span>
                {{ row.reportedAt | legfiDate: 'MM/DD/YYYY' }}
                <app-status-chip [statusId]="row.violationStatusId"
                                 [label]="'Violation status'"
                                 [statuses]="statuses.data"
                                 (statusSelected)="openStatusChange(row)"
                                 preventClick>
                </app-status-chip>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[1].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.title">
            <app-avatar-block [svgIcon]="'v2:fi-br-triangle-warning'">
                <a [routerLink]="[row.id, 'details']" [queryParams]="queryParams" avatarTitle>{{ row.title }}</a>
                <span avatarDescription>{{ row.organization.name }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef><span class="no-wrap">{{ columnMap[2].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!statuses || statuses.data.length === 0" preventClick>
            <app-status-chip [statusId]="row.violationStatusId"
                             [label]="'Violation status'"
                             [statuses]="statuses.data"
                             (statusSelected)="openStatusChange(row)">
            </app-status-chip>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="unit">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[3].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.unit">
            {{ row.unit.title }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="owner">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[4].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.unit || !row.unit.owners">
            <span class="stacked">
                <ng-container *ngFor="let owner of row.unit.owners; let isLast = last">
                    <span>{{ owner.name }}<ng-container *ngIf="row.unit.owners.length > 1 && !isLast">, </ng-container></span>
                </ng-container>
            </span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="reportedAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span class="no-wrap">{{ columnMap[5].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.reportedAt">
            {{ row.reportedAt | legfiDate: 'MM/DD/YYYY' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="resolutionTime">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span class="no-wrap">{{ columnMap[6].title }}</span></mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.resolutionTime">
            {{ row.resolutionTime | legfiDate: 'MM/DD/YYYY' }}
        </mat-cell>
    </ng-container>

    <app-empty-state [icon]="'violations'">
        <span emptyStateTitle>{{ 'No violations so far...' }}</span>
    </app-empty-state>
</app-table>
